export const PHONE_REGEX_DIGITS = /^\d{10,11}$/;
export const PHONE_REGEX_FORMATTED = /^\(?\d{2}\)?\s?9?\d{4}-?\d{4}$/;

const INVALID_MOBILE_DDDS = new Set(['00', '99', '01']);

export function isValidPhone(input) {
  if (!input) return false;
  const digits = String(input).replace(/\D/g, '');
  if (!PHONE_REGEX_DIGITS.test(digits)) return false;
  if (/^(\d)\1{9,10}$/.test(digits)) return false; // reject all same digits
  return true;
}

/** Celular BR: 11 dígitos, DDD obrigatório, 9 na posição do celular, DDD não pode ser 00, 99 ou 01. */
export function isValidBrazilianMobile(input) {
  if (!input) return false;
  const digits = String(input).replace(/\D/g, '');
  if (digits.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(digits)) return false;
  const ddd = digits.slice(0, 2);
  if (INVALID_MOBILE_DDDS.has(ddd)) return false;
  if (digits.charAt(2) !== '9') return false;
  return true;
}

export function formatPhone(value) {
  const digits = String(value).replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 2) return digits;
  if (digits.length <= 6) return digits.replace(/(\d{2})(\d+)/, '($1) $2');
  if (digits.length <= 10)
    return digits.replace(/(\d{2})(\d{4})(\d+)/, '($1) $2-$3');
  return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
}
